export const makeRutubeVideoThumbnail = (videoId: string) => {
    if (videoId === '554bc27b2c2541bb230458618b47d6ed') {
        return 'https://pic.rutubelist.ru/video/2024-10-15/05/c3/05c391ddeab92a53f4411ab1991e374d.jpg';
    }

    return '';
};

export const makeRutubeLink = (videoId: string) => `https://rutube.ru/play/embed/${videoId}/`;
